"use strict";
window.Decidim = window.Decidim || {};
window.Decidim.config = window.Decidim.config || {
  _data: {},
  get: function(key) {
    return this._data[key];
  },
  set: function(config) {
    Object.assign(this._data, config);
  }
};
if (!window.Decidim.config.get("consent_cookie_name")) {
  window.Decidim.config.set({ consent_cookie_name: "decidim-consent" });
}
localStorage.setItem("pwaInstallPromptSeen", true);
if ("serviceWorker" in navigator && process.env.NODE_ENV !== "production") {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}
require.context("../../images", true);
import "../../stylesheets/decidim/decidim_application.scss";
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
const originalXHROpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function(method, url, ...rest) {
  this._isDirectUpload = url && url.includes("/rails/active_storage/direct_uploads");
  return originalXHROpen.apply(this, [method, url, ...rest]);
};
const originalXHRSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function(...args) {
  var _a;
  if (this._isDirectUpload) {
    const csrfToken = (_a = document.querySelector("meta[name='csrf-token']")) == null ? void 0 : _a.getAttribute("content");
    if (csrfToken) {
      this.setRequestHeader("X-CSRF-Token", csrfToken);
    }
  }
  return originalXHRSend.apply(this, args);
};
const rootScope = typeof globalThis === "undefined" ? void 0 : globalThis;
if (rootScope) {
  rootScope.Decidim = rootScope.Decidim || {};
  rootScope.Decidim.currentDialogs = rootScope.Decidim.currentDialogs || {};
  if (typeof document !== "undefined" && typeof globalThis.window !== "undefined") {
    const hostname = globalThis.window.location.hostname;
    const cookieDomain = hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname) ? "" : hostname;
    rootScope.Decidim.cookieDomain = cookieDomain;
  }
}
const ensureNewsletterModalFallback = () => {
  var _a;
  if (typeof document === "undefined") {
    return;
  }
  const modalId = "sign-up-newsletter-modal";
  const registerForm = document.getElementById("register-form");
  const omniauthForm = document.getElementById("omniauth-register-form");
  if (!registerForm && !omniauthForm) {
    return;
  }
  let modal = document.getElementById(modalId);
  const dialogs = (_a = rootScope == null ? void 0 : rootScope.Decidim) == null ? void 0 : _a.currentDialogs;
  const shouldBypassModal = !modal || !(dialogs == null ? void 0 : dialogs[modalId]);
  if (!shouldBypassModal) {
    return;
  }
  if (!modal) {
    modal = document.createElement("div");
    modal.id = modalId;
    modal.hidden = true;
    if (document.body) {
      document.body.appendChild(modal);
    }
  }
  if (modal) {
    modal.dataset.continue = "true";
  }
};
if (typeof document !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensureNewsletterModalFallback, { once: true });
  } else {
    ensureNewsletterModalFallback();
  }
}
